











import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '@/components/atoms/Icon/XIcon.vue'
import XButton from '@/components/atoms/Button/XButton.vue'

export type SocialType = 'facebook' | 'twitter' | 'instagram'

type SocialIcon = {
  [key in SocialType]: IconProps
}

const socialIcons: SocialIcon = {
  facebook: { name: 'facebook-f', type: 'font-awesome' },
  twitter: { name: 'mdi-twitter', type: 'material' },
  instagram: { name: 'mdi-instagram', type: 'material' },
}

type Props = {
  type: SocialType
}

export default Vue.extend<{}, {}, {}, Props>({
  name: 'XSocialButton',
  components: { XIcon, XButton },
  props: {
    type: {
      type: String as PropType<SocialType>,
    },
  },
  computed: {
    icon() {
      return socialIcons[this.type]
    },
  },
})
